import { Injectable, PipeTransform, Pipe,EventEmitter } from '@angular/core';
import { AbstractControl, ValidatorFn, FormControl } from '@angular/forms';
  
 
@Injectable({
  providedIn: 'root'
})
export class CustomValidators {
  public user;
   
  constructor() { 
   
    
  }
  static MustMatch(obj:object, matchingControlName: string,fromName: string="form"):ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
       
      if(!obj[fromName] || !obj[fromName].controls)
        return null;
        const matchingControl = obj[fromName].controls[matchingControlName];
  
      
         
        // set error on matchingControl if validation fails
        if (control.value !== matchingControl.value) {
           return { "Password and confirm password should be same. ": true };
        } else {
          return null;
        }
       
    }
  }
  static MustNotMatch(obj:object, matchingControlName: string):ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      
      if(!obj["form"] || !obj["form"].controls)
        return null;
        const matchingControl = obj["form"].controls[matchingControlName];
  
      
         
        // set error on matchingControl if validation fails
        if (control.value == matchingControl.value) {
           return { "Primary language and Secondary language should not be same. ": true };
        } else {
          return null;
        }
       
    }
  }


  static onlyCharACF():ValidatorFn{
    return (control: AbstractControl): { [key: string]: boolean } | null => {
     
      if(control.value=="")
      return null;
      let re = new RegExp("^[a-zA-Z0-9 \,\.\']*$");
      if (re.test(control.value )) {
        return null;
      } else {
        return { "This field can only contain letters and numbers. ": true };
      }
      
    }

  }
  static onlyChar():ValidatorFn{
    return (control: AbstractControl): { [key: string]: boolean } | null => {
     
      if(control.value=="")
      return null;
      let re = new RegExp("^[a-zA-Z ]*$");
      if (re.test(control.value )) {
        return null;
      } else {
        return { "This field can only contain letters. ": true };
      }
      
    }

  }
  static isValidMailFormat():ValidatorFn{
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      console.log(control,'control.value')
      if(!control.value)
      return null;
      let re =  /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
      if (!re.test(control.value.trim())) {
        return { "Please provide a valid email": true };
      }
      
        return null;
      
      
    }

  }
 
  static onlyAlphaNumeric():ValidatorFn{
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      
      if(!control.value || control.value=="")
        return null;
      let re = new RegExp(/^[a-zA-Z0-9 ]+$/);
      if (re.test(control.value )) {
        return null;
      } else {
        return { "This field can only contain alphanumeric. ": true };
      }
      
    }

  }

    static onlyAlphaNumericWithoutSpace():ValidatorFn{
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      
      if(!control.value || control.value=="")
        return null;
      let re = new RegExp(/^[a-zA-Z0-9]*$/);


      if (re.test(control.value )) {
        return null;
      } else {
        return { "This field can only contain alphanumeric without space. ": true };
      }
      
    }

  }

  static passwordStrength():ValidatorFn{
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      
      if(!control.value || control.value=="")
        return null;

        var hasSpecial = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(control.value);//special char
        let hasNumber = /\d/.test(control.value);
        let hasUpper = /[A-Z]/.test(control.value);
        let hasLower = /[a-z]/.test(control.value);
        
        const valid = hasNumber && hasUpper && hasLower && hasSpecial;
        

      if (valid) {
        return null;
      } else {
        return { "The field should contain at least one number, uppercase, lowercase and special character.": true };
      }
      
    }

  }

 

 
  static onlyNumberDecimal():ValidatorFn{
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      
      if(!control.value || control.value=="")
        return null;
     
      var regexp = /^[0-9]+([,.][0-9]+)?$/g;
      if (regexp.test(control.value )) {
        return null;
      } else {
        return { "This field can only contain numbers and decimal. ": true };
      }
      
    }

  }
  static onlyNumber():ValidatorFn{
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      
      if(!control.value || control.value=="")
        return null;
      let re = new RegExp("^[0-9]+$");
      if (re.test(control.value )) {
        return null;
      } else {
        return { "This field can only contain numbers. ": true };
      }
      
    }

  }

  static onlyUrl():ValidatorFn{
    return (control: AbstractControl): { [key: string]: boolean } | null => {
     
      if(!control.value || control.value=="")
        return null;
      let re = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;//new RegExp("^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}");
      if (re.test(control.value )) {
        return null;
      } else {
        return { "This field can only contain url.": true };
      }
      
    }

  }
  

 
}
 
